module.exports = __webpack_public_path__ + "img/team2.df14829d.jpg";